import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  filterByData: {},
  isBulkUploadModalOpen: false,
  deleteModalStats: {
    isOpen: false,
    type: "",
  },
  deleteRowDetails: {},
  addEditModalStats: {
    isOpen: false,
    type: "", // add Question: 'add' , edit Question: 'edit',  Add topic: 'addTopic', Edit topic: 'editTopic'
  },
  selectedPage: 1,
  tableData: {},
  filterByLoader: {
    isLoading: false,
    type: "",
  },
  isTableLoading: false,
};
const questionBankSlice = createSlice({
  name: "questionBank",
  initialState,
  reducers: {
    setFilterData: (state, action) => {
      state.filterByData = { ...action.payload };
    },
    setAddEditModalStats: (state, action) => {
      state.addEditModalStats = { ...action.payload };
    },
    setIsBulkUploadModalOpen: (state, action) => {
      state.isBulkUploadModalOpen = action.payload;
    },
    setDeleteModalStats: (state, action) => {
      state.deleteModalStats = { ...action.payload };
    },
    setDeleteRowDetails: (state, action) => {
      state.deleteRowDetails = { ...action.payload };
    },
    setSelectedPage: (state, action) => {
      state.selectedPage = action.payload;
    },
    setTableData: (state, action) => {
      state.tableData = { ...action.payload };
    },
    setFilterByLoader: (state, action) => {
      state.filterByLoader = { ...action.payload };
    },
    setIsTableLoading: (state, action) => {
      state.isTableLoading = action.payload;
    },
  },
});

export const {
  setFilterData,
  setAddEditModalStats,
  setIsBulkUploadModalOpen,
  setDeleteModalStats,
  setDeleteRowDetails,
  setSelectedPage,
  setTableData,
  setFilterByLoader,
  setIsTableLoading,
} = questionBankSlice.actions;

export const fetchFilterByData = (state) => state.questionBank.filterByData;
export const fetchAddEditModalStats = (state) =>
  state.questionBank.addEditModalStats;
export const fetchIsBulkUploadModalOpen = (state) =>
  state.questionBank.isBulkUploadModalOpen;
export const fetchDeleteModalStats = (state) =>
  state.questionBank.deleteModalStats;
export const fetchDeleteRowDetails = (state) =>
  state.questionBank.deleteRowDetails;
export const fetchSelectedPage = (state) => state.questionBank.selectedPage;
export const fetchTableData = (state) => state.questionBank.tableData;
export const fetchFilterByLoader = (state) => state.questionBank.filterByLoader;
export const fetchIsTableLoading = (state) => state.questionBank.isTableLoading;
export default questionBankSlice.reducer;
